// Get All UP Records Constants
export const GET_ALL_UP_RECORDS_REQUEST = 'GET_ALL_UP_RECORDS_REQUEST'
export const GET_ALL_UP_RECORDS_SUCCESS = 'GET_ALL_UP_RECORDS_SUCCESS'
export const GET_ALL_UP_RECORDS_FAIL = 'GET_ALL_UP_RECORDS_FAIL'
export const GET_ALL_UP_RECORDS_RESET = 'GET_ALL_UP_RECORDS_RESET'

// Create UP Record Constants
export const CREATE_UP_RECORD_REQUEST = 'CREATE_UP_RECORD_REQUEST'
export const CREATE_UP_RECORD_SUCCESS = 'CREATE_UP_RECORD_SUCCESS'
export const CREATE_UP_RECORD_FAIL = 'CREATE_UP_RECORD_FAIL'
export const CREATE_UP_RECORD_RESET = 'CREATE_UP_RECORD_RESET'

// Update UP Record Constants
export const UPDATE_UP_RECORD_REQUEST = 'UPDATE_UP_RECORD_REQUEST'
export const UPDATE_UP_RECORD_SUCCESS = 'UPDATE_UP_RECORD_SUCCESS'
export const UPDATE_UP_RECORD_FAIL = 'UPDATE_UP_RECORD_FAIL'
export const UPDATE_UP_RECORD_RESET = 'UPDATE_UP_RECORD_RESET'

// Delete UP Record Constants
export const DELETE_UP_RECORD_REQUEST = 'DELETE_UP_RECORD_REQUEST'
export const DELETE_UP_RECORD_SUCCESS = 'DELETE_UP_RECORD_SUCCESS'
export const DELETE_UP_RECORD_FAIL = 'DELETE_UP_RECORD_FAIL'
export const DELETE_UP_RECORD_RESET = 'DELETE_UP_RECORD_RESET'

// Import UP Records Constants
export const IMPORT_UP_RECORDS_REQUEST = 'IMPORT_UP_RECORDS_REQUEST'
export const IMPORT_UP_RECORDS_SUCCESS = 'IMPORT_UP_RECORDS_SUCCESS'
export const IMPORT_UP_RECORDS_FAIL = 'IMPORT_UP_RECORDS_FAIL'
export const IMPORT_UP_RECORDS_RESET = 'IMPORT_UP_RECORDS_RESET'

// Export UP Records Constants
export const EXPORT_UP_RECORDS_REQUEST = 'EXPORT_UP_RECORDS_REQUEST'
export const EXPORT_UP_RECORDS_SUCCESS = 'EXPORT_UP_RECORDS_SUCCESS'
export const EXPORT_UP_RECORDS_FAIL = 'EXPORT_UP_RECORDS_FAIL'
export const EXPORT_UP_RECORDS_RESET = 'EXPORT_UP_RECORDS_RESET'

// Add these missing constants to upConstants.js:

// Bulk Delete UP Records Constants
export const BULK_DELETE_UP_RECORDS_REQUEST = 'BULK_DELETE_UP_RECORDS_REQUEST'
export const BULK_DELETE_UP_RECORDS_SUCCESS = 'BULK_DELETE_UP_RECORDS_SUCCESS'
export const BULK_DELETE_UP_RECORDS_FAIL = 'BULK_DELETE_UP_RECORDS_FAIL'
export const BULK_DELETE_UP_RECORDS_RESET = 'BULK_DELETE_UP_RECORDS_RESET'

// Add these new constants at the end of the file
export const SYNC_UP_TASK_STATUS_REQUEST = 'SYNC_UP_TASK_STATUS_REQUEST';
export const SYNC_UP_TASK_STATUS_SUCCESS = 'SYNC_UP_TASK_STATUS_SUCCESS';
export const SYNC_UP_TASK_STATUS_FAIL = 'SYNC_UP_TASK_STATUS_FAIL';
export const SYNC_UP_TASK_STATUS_RESET = 'SYNC_UP_TASK_STATUS_RESET';